// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609280529/js/" + chunkId + "." + {"44":"dcc6a916","225":"58c8d489","481":"d92641e1","486":"2b31d99e","770":"4df5fcd8"}[chunkId] + ".0.3999570208219273.chunk.js";
};